module.exports = __webpack_public_path__ + "static/media/digital_menu_pricing.4e62463c.svg";